import { makeScalarToken } from './token.scalar.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// combineToken accepts multiple different kinds of inputs, which are each going
// to be processed in different ways

// the overall input signature for the method will consist of a tuple of inputs,
// which will in turn create an output record of tokens based on that input

// finally we need a validation of tuple based inputs, where we need to
// guarantee that the input matches what's expected by the maker callback,
// otherwise we loose type-safety of inputs in the following shape:
//
// { invalidColor: ["not a color", makeColorToken] }

/**
 * combine a record of tokens under a singular namespace, so that they are
 * easily distinguishable within the browser developer tools, and that they can
 * be overridden together in a single callback
 */
function combineTokens(propName, tokens) {
  const combinedTokens = Object.fromEntries(Object.entries(tokens).map(([key, item]) => {
    const nestedName = `${propName}--${key}`;
    if (Array.isArray(item)) {
      const [input, factory] = item;
      return [key, factory(nestedName, input)];
    } else if (typeof item === "function") {
      return [key, item.__extend(nestedName)];
    } else {
      return [key, makeScalarToken(nestedName, item)];
    }
  }));
  Object.defineProperties(combinedTokens, {
    propName: {
      enumerable: false,
      value: propName
    },
    __override: {
      enumerable: false,
      value: input => {
        const output = Object.entries(input).reduce((acc, [key, nextValue]) => {
          return {
            ...acc,
            ...combinedTokens[key]?.__override(nextValue)
          };
        }, {});

        // define a toString() method, which will translate the CSS property
        // record into a valid CSS string that can be interpolated into e.g.
        // linaria
        Object.defineProperty(output, "toString", {
          enumerable: false,
          value: () => {
            const css = Object.entries(output).flatMap(([key, value]) => `${key}:${value}`).join(";");
            return css ? `${css};` : "";
          }
        });
        return output;
      }
    },
    __extend: {
      enumerable: false,
      value: extendedPropName => {
        return combineTokens(extendedPropName, combinedTokens);
      }
    }
  });
  return combinedTokens;
}

export { combineTokens };
//# sourceMappingURL=util.combine-tokens.js.map
